module.exports = __webpack_public_path__ + "static/media/activity_type_spiritueel_inverted.2e8a46c8.svg";